/** 远程配置地址：返回 JSON，取 apiurl 字段作为 API 根地址 */
export const REMOTE_CONFIG_URL =
  process.env.NODE_ENV === "development"
    ? "/remote-config/anbo.txt"
    : "https://onetokenapp.s3.ap-east-1.amazonaws.com/anbo.txt";
